import React from 'react';

export default function SectionHeader({ eyebrow, title, subtitle, align = 'center', dark = false }) {
  const alignCls = align === 'center' ? 'text-center items-center' : 'text-left items-start';
  const eyebrowColor = dark ? 'text-[#F5EFE6]/60' : 'text-[#1A2332]/60';
  const titleColor = dark ? 'text-[#F5EFE6]' : 'text-[#1A2332]';
  const subColor = dark ? 'text-[#F5EFE6]/70' : 'text-[#1A2332]/60';

  return (
    <div className={`flex flex-col ${alignCls}`}>
      {eyebrow && (
        <p className={`text-[10px] md:text-[11px] tracking-[0.35em] sm:tracking-[0.45em] uppercase ${eyebrowColor} mb-3`}>{eyebrow}</p>
      )}
      <h2 className={`font-serif-display text-2xl sm:text-3xl md:text-5xl leading-tight ${titleColor}`}>{title}</h2>
      <div className="flex items-center gap-3 mt-4">
        <span className="h-px w-8 bg-[#C9A961]"></span>
        <span className="w-1.5 h-1.5 rotate-45 bg-[#C9A961]"></span>
        <span className="h-px w-8 bg-[#C9A961]"></span>
      </div>
      {subtitle && <p className={`mt-4 max-w-xl text-sm md:text-base ${subColor} font-serif-body italic`}>{subtitle}</p>}
    </div>
  );
}
